import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'User initiates caption creation on a video',
  name: 'caption_generation_started',
  params: [
    {
      description: 'The id of the video',
      name: 'video_id',
      required: true,
      type: 'string',
    },
    {
      description: 'Duration of the video in seconds',
      name: 'duration_seconds',
      required: true,
      type: 'number',
    },
  ],
};

export default META;
